// vim: set ts=2 sts=2 sw=2 et:

import React from "react";
import { Link } from "react-router-dom";

import { useLabBody } from "./LabStage";

import styles from "./Lab.module.scss";

// Banco de pruebas de diseño: pantallas con datos de ejemplo, sin live server ni torneo cargado.
const LAB_PAGES = [
  {
    to: "/lab/overlay",
    title: "Overlay de transmisión",
    description: "Fusión elegida (header de B + footer de A) y las dos propuestas de referencia.",
  },
  {
    to: "/lab/ficha",
    title: "Ficha del atleta",
    description: "Foto, datos, peso en barra, lo levantado en el torneo y marcas previas, con la piel del overlay.",
  },
  {
    to: "/lab/en-vivo",
    title: "Pantallas en vivo",
    description: "Espectador, overlay y ficha de producción conectados a una sala simulada con las escenas del lab.",
  },
];

const LabIndexRoute = () => {
  useLabBody();
  return (
    <main className={styles.index}>
      <h1>Lab</h1>
      <p>Diseños en prueba con datos de ejemplo. Nada de esto se conecta al torneo.</p>
      <ul>
        {LAB_PAGES.map((page) => (
          <li key={page.to}>
            <Link to={page.to}>
              <strong>{page.title}</strong>
              <span>{page.description}</span>
            </Link>
          </li>
        ))}
      </ul>
    </main>
  );
};

export default LabIndexRoute;
